import { connect } from "react-redux";
import DriverStates from "../../../components/DriverStates";
import { getTransfertDrivers } from "../selectors";
import {withRouter} from "react-router-dom";

export default withRouter(connect(
  state => ({ drivers: getTransfertDrivers(state) })
)(DriverStates));
